import api from './api';

// Register a new user
export const register = async (userData) => {
  try {
    const response = await api.post('/api/auth/register', userData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Login user
export const login = async (userData) => {
  try {
    const response = await api.post('/api/auth/login', userData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get user profile
export const getProfile = async (token) => {
  const response = await api.get('/api/auth/profile', {
    headers: { 'x-auth-token': token }
  });
  return response.data;
};

// Public: is registration open, invite-only, or closed?
export const getSignupStatus = async () => {
  const response = await api.get('/api/auth/signup-status');
  return response.data;
};

// Describes a personal invitation link (/register?invite=TOKEN):
// { valid: true, email, expiresAt } or { valid: false, reason }
export const getSignupInvitation = async (token) => {
  const response = await api.get(`/api/auth/invitation/${encodeURIComponent(token)}`);
  return response.data;
};
